import React, { useState } from "react";
import {
  Card,
  Box,
  Modal,
  IconButton,
  Typography,
  Button,
  Link,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import imageIndex from "../ImageIndex";

const BecomeSponsor = () => {
  const [open, setOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const GradientButton = ({ to, children }) => {
    const handleClick = (e) => {
      e.stopPropagation();
      window.open(to, "_blank");
    };

    return (
      <Link
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        underline="none"
      >
        <Button
          onClick={handleClick}
          sx={{
            alignItems: "center",
            backgroundImage:
              "linear-gradient(144deg,#AF40FF, #5B42F3 50%,#00DDEB)",
            border: 0,
            borderRadius: "8px",
            boxShadow: "rgba(151, 65, 252, 0.2) 0 15px 30px -5px",
            boxSizing: "border-box",
            color: "#FFFFFF",
            display: "flex",
            fontFamily: "Phantomsans, sans-serif",
            fontSize: { xs: "20px", md: "25px" },
            justifyContent: "center",
            lineHeight: "1em",
            maxWidth: "100%",
            minWidth: { xs: "150px", md: "180px" },
            maxHeight: "100%",
            minHeight: { xs: "40px", md: "50px" },
            padding: "3px",
            textDecoration: "none",
            userSelect: "none",
            WebkitUserSelect: "none",
            cursor: "pointer",
            transition: "all 300ms ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
              boxShadow: "rgba(47, 154, 255, 0.4) 0 20px 40px -10px",
              backgroundImage:
                "linear-gradient(144deg, rgba(60,235,255,1), rgba(10,181,198,1) 50%, rgba(0,137,150,1))",
            },
          }}
        >
          <span
            style={{
              backgroundColor: "rgb(5, 6, 45)",
              padding: "5px 24px",
              borderRadius: "6px",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "300ms",
            }}
          >
            {children}
          </span>
        </Button>
      </Link>
    );
  };

  return (
    <>
      {/* Title Section - Wider */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 850,
          margin: "0 auto",
          textAlign: "center",
          mb: 2,
          px: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "clamp(3rem, 10vw, 3.5rem)",
            display: "block",
            lineHeight: 1.2,
          }}
        >
          Impulsa el sector aeroespacial
        </Typography>
        <Typography
          component="span"
          variant="h1"
          sx={{
            fontSize: "clamp(3rem, 10vw, 3.5rem)",
            display: "block",
            color: (theme) =>
              theme.palette.mode === "dark" ? "primary.light" : "primary.main",
            lineHeight: 1.2,
          }}
        >
          con nosotros
        </Typography>
      </Box>

      {/* Image Container*/}
      <Box
        sx={{
          width: "100%",
          maxWidth: 450,
          position: "relative",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          gap: isMobile ? 2 : 0, // Add gap only on mobile
        }}
      >
        <Card
          onClick={handleOpen}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => !isMobile && setIsHovered(false)}
          sx={{
            position: "relative",
            overflow: "hidden",
            width: "100%",
            aspectRatio: "3/4",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              border: "2px solid transparent",
              borderRadius: "inherit",
              background:
                "linear-gradient(90deg, #3f51b5, #2196f3, #3f51b5) border-box",
              WebkitMask:
                "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
              WebkitMaskComposite: "destination-out",
              maskComposite: "exclude",
              animation: "borderAnimation 3s linear infinite",
            },
            transform: "perspective(1000px)",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            "&:hover": {
              cursor: "pointer",
              "&::before": {
                animation: "borderAnimation 1.5s linear infinite",
              },
            },
          }}
        >
          <Box
            component="img"
            src={imageIndex.ENMICE2025Patrocinios}
            alt="Gallery item"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "all 0.3s ease",
              padding: "4px",
              filter: isHovered ? "blur(2px) brightness(0.7)" : "none",
              transform: isHovered ? "scale(1.01)" : "scale(1)",
            }}
          />

          {/* Hover Button (Desktop only) */}
          {!isMobile && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: isHovered ? 1 : 0,
                transition: "opacity 0.3s ease",
                zIndex: 1,
                pointerEvents: isHovered ? "auto" : "none",
              }}
            >
              <GradientButton to="https://bit.ly/PatrociniosENMICE">
                Conviértete en patrocinador
              </GradientButton>
            </Box>
          )}
        </Card>

        {/* Mobile Button (shown below image) */}
        {isMobile && (
          <GradientButton to="https://bit.ly/PatrociniosENMICE">
            Conviértete en patrocinador
          </GradientButton>
        )}
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(4px)",
        }}
      >
        <Box
          sx={{
            position: "relative",
            maxWidth: "90vw",
            maxHeight: "90vh",
            overflow: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 1,
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "grey.500",
              bgcolor: "background.paper",
              "&:hover": {
                bgcolor: "grey.200",
              },
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            component="img"
            src={imageIndex.ENMICE2025Patrocinios}
            alt="Featured content enlarged"
            sx={{
              width: "100%",
              height: "auto",
              maxWidth: "100%",
              display: "block",
            }}
          />
        </Box>
      </Modal>

      <style jsx global>{`
        @keyframes borderAnimation {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 200% 50%;
          }
        }
      `}</style>
    </>
  );
};

export default BecomeSponsor;
